import React from "react";
import styles from "./SideSection.module.scss";

const SideSection = () => {
  return (
    <div className={styles.container}>
      <ul>
        <li>
          <p>Type</p>
          <i class="fas fa-angle-down"></i>
        </li>
        <li>
          <p>Price</p>
          <i class="fas fa-angle-down"></i>
        </li>
        <li>
          <p>Categories</p>
          <i class="fas fa-angle-down"></i>
        </li>
      </ul>
    </div>
  );
};

export default SideSection;
